import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/router.js'
import http from "./api/request";
import Vant from 'vant';
import 'vant/lib/index.css';
import htmlToPdf from '@/plugins/htmlToPdf'
import UrlEncode from './api/UrlEncode.js'
Vue.prototype.$UrlEncode = UrlEncode;
Vue.prototype.$http = http;
Vue.config.productionTip = false
Vue.use(htmlToPdf)
Vue.use(ElementUI)
Vue.use(Vant);
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')